import {
  createStyles,
  IconButton,
  Theme,
  withStyles
} from "@material-ui/core";
import { IconButtonProps } from "@material-ui/core/IconButton";
import React from "react";

function requireIcon(icon: IconTypes) {
  switch (icon) {
    case "close": {
      return require("../assets/images/bb8-close.svg");
    }
    case "pinned": {
      return require("../assets/images/bb8-pinned.svg");
    }
    default:
      return;
  }
}

type IconTypes = "close" | "pinned";

const styles = createStyles((theme: Theme) => ({
  root: { height: "44px", width: "44px" }
}));

interface IProps extends IconButtonProps {
  icon: IconTypes;
}

const BB8IconButton: React.SFC<IProps> = props => {
  const { icon, classes, ...others } = props;
  const iconElement = requireIcon(icon);
  return (
    <IconButton {...others} className={classes!.root}>
      <img src={iconElement} />
    </IconButton>
  );
};

export default withStyles(styles)(BB8IconButton);
